import { Link } from "react-router-dom";
import "./PortfolioStyle.css";
import { useState } from "react";

const ProjectCard = ({
  id,
  title,
  image,
  description,
  technologies,
  url,
  githubUrl,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div 
        className={`project-card-modern ${isHovered ? 'hovered' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Featured Badge */}
        {id === "featured" && (
          <div className="featured-badge">
            <i className="fa fa-star"></i> Featured
          </div>
        )}
        
        {/* Project Image */}
        <div className="project-image-wrapper">
          <img 
            src={image} 
            alt={title} 
            className="project-image-modern" 
          />
          
          {/* Gradient Overlay */}
          <div className="image-gradient-overlay"></div>
          
          {/* Project Title Overlay */}
          <div className="project-title-overlay">
            <h3>{title}</h3>
          </div>
        </div>
        
        {/* Project Content */}
        <div className="project-content">
          {/* Description */}
          <p className="project-description">{description}</p>
          
          {/* Tech Stack */}
          <div className="tech-stack">
            {technologies && technologies.map((tech, index) => (
              <span key={index} className="tech-badge">
                {tech}
              </span>
            ))}
          </div>
          
          {/* Action Buttons */}
          <div className="project-actions">
            <Link 
              to={url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="action-btn primary-btn"
            >
              <i className="fa fa-external-link-alt"></i> Live Demo
            </Link>
            
            {githubUrl && (
              <Link 
                to={githubUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="action-btn secondary-btn"
              >
                <i className="fa fa-code"></i> View Code
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
